
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/wymiana-karty",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/wymiana-karty/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/wymiana-karty"])
      });
    }
  